<template>
  <div>
    <!-- @cancel="abrirModal('ModalNotaAutomatica')" -->
    <!-- @confirm="abrirModal('ModalNotaManual')" -->
    <el-popconfirm
        cancelButtonText="Automática"
        cancelButtonType="warning"
        confirmButtonText="Manual"
        confirmButtonType="success"
        icon="el-icon-info"
        iconColor="green"
        title="Cadastrar Nota: "
        @cancel="abrirModal('ModalNotaAutomatica')"
        @confirm="abrirModal('ModalNotaManual')"
    >
      <!-- BLOQUEAR OS BOTÕES CASO O CLIENTE TENHA SIDO SUSPENSO -->
      <vs-button
          slot="reference"
          :disabled="
        fatura.id_status === 3 || (
          !$atividades.permissoes.includes(25) &&
          (
            !$atividades.permissoes.includes(5) ||
            (fatura.status_notas != null && fatura.lixeira == 0 && fatura.status_notas != 4) ||
            contrato.contrato_parcelas_atrasadas >= 6
          )
        )
      "
          color="success"
          icon="note"
          radius
          size="small"
          type="relief"
      ></vs-button>

    </el-popconfirm>
    <component
        v-bind:is="modal"
        :key="reRenderModal"
        :contrato="contrato"
        :fatura="fatura"
        @update="update"
    />
  </div>
</template>
<script>
import components from "@/components/default/exports.js";
import ModalNotaAutomatica from "./components/notaAutomatica";
import ModalNotaManual from "./components/notaManual";

export default {
  props: {
    fatura: null,
    contrato: {},
  },
  data() {
    return {
      modal: "",
      reRenderModal: 0,
    };
  },
  methods: {
    async abrirModal(modal) {
      this.modal = modal;
      this.reRenderModal += 1;
    },
    async update() {
      await this.$emit("update");
    },
  },
  components: {
    ...components,
    ModalNotaAutomatica,
    ModalNotaManual,
  },
};
</script>
<style>
.el-popconfirm__main {
  font-size: 14px !important;
}

.el-button--warning {
  background-color: #0f4084 !important;
  border-color: #0f4084 !important;
}

.el-button--success {
  background-color: #00bba2 !important;
  border-color: #00bba2 !important;
}
</style>
